import { useState } from "react";
import { Link } from "react-router";
import Ad from "@components/Advertisement/Ad";
import { AwardType } from "@events-awards/utils/types";
import { cn } from "@util/helpers";

import EventsAwardsLogo from "./EventsAwardsLogo";
import EventsAwardsNavigationMenu from "./EventsAwardsNavigationMenu";
import { getHomePageLink, getNavigationConstants } from "./helper";
import SideMenu from "./SideMenu";
import ToggleSideMenuButton from "./ToggleSideMenuButton";

type EventsAwardsNavigationBarProps = {
  /** The award type is used to display navigation bar based on the type of awards i.e (SIA, SBA, etc...). */
  awardType: string;
};

/**
 * Events Awards Navigation Bar component
 */
const EventsAwardsNavigationBar = ({
  awardType,
}: EventsAwardsNavigationBarProps): React.ReactElement => {
  const [open, setOpen] = useState(false);

  const toggleSideMenu = () => {
    setOpen(!open);
  };

  return (
    <>
      <div
        data-testid="events-awards-navigation-bar-component"
        className={cn("hidden flex-row items-center justify-between lg:flex", {
          "py-2 pb-3": awardType === AwardType.SBA,
          "-mt-4": awardType === AwardType.DATA,
        })}
      >
        <Link
          to={getHomePageLink(awardType)}
          className={cn("flex", {
            "mt-3": awardType === AwardType.EE,
          })}
          reloadDocument
        >
          <EventsAwardsLogo awardType={awardType} />
        </Link>

        <EventsAwardsNavigationMenu
          menuData={getNavigationConstants(awardType) || []}
          className="mt-0 border-none"
        />
      </div>

      <div className="w-full lg:hidden">
        <div
          className={cn("flex items-center justify-between", {
            "my-10": awardType === AwardType.SBA,
          })}
        >
          <Link
            to={getHomePageLink(awardType)}
            reloadDocument
            className={cn({
              "mt-3": awardType === AwardType.EE,
            })}
          >
            <EventsAwardsLogo awardType={awardType} />
          </Link>

          <ToggleSideMenuButton onClick={toggleSideMenu} open={open} />
        </div>

        {open ? (
          <SideMenu data={getNavigationConstants(awardType) || []} />
        ) : null}
      </div>

      <Ad
        adType="lb1"
        className={cn(
          "my-5 flex min-h-[calc(50px+0.50rem)] flex-col items-center justify-center text-center md:py-3"
        )}
      />
    </>
  );
};

export default EventsAwardsNavigationBar;
